//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- EXPORTAÇÃO DO SERVIÇO LOAD COMPANIES ---------------//
// Responsável por requisitar à API as empresas existentes ao usuário
export default async function updateGroupService(groupId, name) {
    try {
        if (!name.trim()) { 
            toast.warn("Informe um nome de grupo");
            return false;
        }
        await api.put(`/grupos-produtos/${groupId}`, { nome: name });
        toast.success("Grupo atualizado com sucesso");
        return true;
    } catch (error) {
        toast.error("Erro ao atualizar grupo");
        return false;
    }
}